import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Checkbox,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
  } from '@chakra-ui/react';
  import {Router, Link} from 'react-router-dom' 
  
  export default function SimpleCard() {
    return (
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('grey.50', 'gray.00')}>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'}>Seeking Talent? </Heading>
            <Text fontSize={'md'} color={'gray.600'}>
            Join BlockFuse to scout, sponsor new skillsets, or to meet degen professionals.            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('orange.500', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <FormControl id="email">
                <FormLabel>Email address:</FormLabel>
                <Input type="email" />
              </FormControl>
              <FormControl id="name">
                <FormLabel>Company:</FormLabel>
                <Input type="text" />
              </FormControl>
              <FormControl id="password">
                <FormLabel>Password:</FormLabel>
                <Input type="password" />
              </FormControl>
              <FormControl id="confirm-password">
                <FormLabel>Confirm Password:</FormLabel>
                <Input type="password" />
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: 'column', sm: 'row' }}
                  align={'start'}
                  justify={'space-between'}>
                  <Checkbox>Remember me</Checkbox>
                  <Link color={'blue.400'}>Forgot password?</Link>
                </Stack>
                <Link to='/signup'>Are you a candidate? Sign Up Here</Link>
                <Button
                  bg={'gray.600'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  Sign Up
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    );
  }